import 'bootstrap/js/src/collapse';

import { initializeMultiPageTest, initializeMultiPageTestResults, quizMeButton } from "../audio-video-qa-base";

const audio = document.querySelector('#media-player');
const listenAgain = document.querySelector('.listen-again');
const transcript = document.getElementById('transcript');
const showTranscriptAudioButton = document.getElementById('show-transcript-audio-button');
const hideTranscriptAudioButton = document.getElementById('hide-transcript-audio-button');

if (listenAgain) {
    const quizButton = document.querySelector('#quiz-button');
    let tracked = false;

    listenAgain.addEventListener('click', () => {
        audio.currentTime = 0;
        audio.play();
        tracked = false;
    });

    if (audio.dataset.completionUrl) {
        audio.addEventListener('timeupdate', function () {
            // If the player has reached 90%
            if (!tracked) {
                if (audio.currentTime > (.9 * audio.duration)) {
                    quizButton.disabled = false;
                    tracked = true;
                    axios
                        .post(audio.dataset.completionUrl)
                        .catch(() => tracked = false);
                }
            }
        });
    }
}

function toggleShowHideTranscriptAudio() {
    if (transcript && showTranscriptAudioButton) {
        $(transcript).on('show.bs.collapse', function () {
            showTranscriptAudioButton.classList.add('d-none');
            hideTranscriptAudioButton.classList.remove('d-none');
        });

        $(transcript).on('hide.bs.collapse', function () {
            hideTranscriptAudioButton.classList.add('d-none');
            showTranscriptAudioButton.classList.remove('d-none');
        });
    }
}

quizMeButton();
toggleShowHideTranscriptAudio();
initializeMultiPageTest();
initializeMultiPageTestResults();
